export class RetturnDTO {
    constructor(
        public orderitem_id: number = 0,
        public q: number = 1,
        public reason: string = "",
        public bankdetails: string = "",
    ) {}    
}
